import { render, staticRenderFns } from "./ModuleToolsWatchOnly.vue?vue&type=template&id=5bf112e9&scoped=true&"
import script from "./ModuleToolsWatchOnly.vue?vue&type=script&lang=js&"
export * from "./ModuleToolsWatchOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf112e9",
  null
  
)

export default component.exports